import { TextLabel } from '@core/components/Inputs';
import { Divider, Grid, makeStyles, Typography } from '@material-ui/core';
import React, { Fragment, useState } from 'react';

const useStyles = makeStyles({
  divider: {
    backgroundColor: 'rgba(0, 0, 0, 0.50)',
    marginBottom: 16,
  },
  dividerTitle: {
    backgroundColor: '#707070',
    marginBottom: 8,
    opacity: '0.5',
  },
  title: {
    fontSize: 15,
    fontWeight: 500,
  },
  viewMore: {
    color: '#53c4e6',
    textTransform: 'capitalize',
    '&:hover, &:focus': {
      cursor: 'pointer',
    },
  },
});

const ListView = ({
  title = 'Item',
  hideTitle = false,
  hideDivider = false,
  showOnlyFirstLabel = false,
  showMoreTitle = 'Ver mais',
  values = [],
  style = {},
  options = [{ title: '', name: '', grid: { xs: 12, sm: 6 } }],
}) => {
  const [tamanho, setTamanho] = useState(5);
  const styles = useStyles();

  const existeMais = values.length - tamanho > 0;
  const listagemGerada = values.slice(0, tamanho).map((value, index) => {
    const gerados = options.map((option, i) => {
      return (
        <Grid key={`${option.name}[${i}]`} item {...option.grid} style={style}>
          <TextLabel
            fullWidth
            id={value[option.name]}
            label={showOnlyFirstLabel ? (index === 0 ? option.title : undefined) : option.title}
            value={option.format ? option.format(value) : value[option.name]}
          />
        </Grid>
      );
    });
    return (
      <Fragment key={index}>
        {!hideTitle && (
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <p className={styles.title}>{`${title} ${index + 1}`}</p>
          </Grid>
        )}

        {!hideDivider && (
          <Grid xs={12} item spacing={3}>
            <Divider className={styles.dividerTitle} />
          </Grid>
        )}
        {gerados}
      </Fragment>
    );
  });
  return (
    values &&
    values.length > 0 && (
      <>
        {listagemGerada}
        {!hideDivider && (
          <Grid xs={12} item spacing={3}>
            <Divider className={styles.divider} />
          </Grid>
        )}
        {existeMais && (
          <Grid xs={12} item spacing={3} style={{ paddingTop: 0 }}>
            <Typography className={styles.viewMore}>
              <b className={styles.viewMore} onClick={() => setTamanho(tamanho + 5)}>
                {showMoreTitle}
              </b>
            </Typography>
          </Grid>
        )}
      </>
    )
  );
};

export default ListView;
